import { useQuery } from "@tanstack/react-query";
import RestAPI from "../../../util/RestAPI";
import { useUserContext } from "../../../context";

export const useFreeTrialAvailable = (type: "7-day" | "30-day") => {
  const { authenticated } = useUserContext();

  const query = useQuery({
    queryKey: ["free-trial", type],
    queryFn: async () => {
      return await RestAPI.get("/users/free-trials/" + type).then(
        async (res) => {
          return (await res.json()) as any as
            | {
                available: true;
              }
            | {
                available: false;
                reason: string;
                message: string;
              };
        }
      );
    },
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    enabled: authenticated,
  });

  return query;
};
